import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

export function useCanonical(baseUrl = 'https://rivhapilates.com') {
  const route = useRoute()

  const updateCanonical = () => {
    const currentPath = route ? route.path : window.location.pathname
    
    const cleanPath = currentPath === '/' ? '' : currentPath.replace(/\/$/, '')
    const fullUrl = `${baseUrl}${cleanPath}`

    let link = document.querySelector('link[rel="canonical"]')
    
    if (!link) {
      link = document.createElement('link')
      link.setAttribute('rel', 'canonical')
      document.head.appendChild(link)
    }
    
    link.setAttribute('href', fullUrl)
  }

  onMounted(() => {
    updateCanonical()
  })

  if (route) {
    watch(() => route.path, () => {
      updateCanonical()
    })
  }
}